import {Box, Link, Text} from '@chakra-ui/react'
import {useTranslation} from 'next-i18next'
import {useEffect, useState} from 'react'
import toast from '_app/utils/toast'
import {Input} from '_app/components/Form'
import {CartAddressInput} from '_app/types/api'
import {AddressDetails} from 'modules/checkout/types'

interface Props {
  onPointNameChange: (pointName: string) => void;
  name?: string;
  onChange: (address: Partial<CartAddressInput>) => void;
}

export const InpostSelect = ({
  onPointNameChange,
  onChange,
  name = 'inpost_point',
}: Props) => {
  const { t } = useTranslation()
  const [inpostAddress, setInpostAddress] =
    useState<{ name: string; address: string }>()

  useEffect(() => {
    if (typeof window !== undefined) {
      window.easyPackAsyncInit = function () {
        window.easyPack?.init({})
      }
    }
  }, [])

  const handleAddressChange = (addressDetails: AddressDetails) => {
    const parsedBuildingNumber = (/^[0-9]+[a-zA-Z0-9/,.\- ]*$/).test(
      addressDetails.building_number
    )
      ? addressDetails.building_number
      : 1

    onChange({
      city: addressDetails.city,
      country_code: 'pl',
      street: [
        addressDetails.street,
        `${parsedBuildingNumber}${
          !!addressDetails.flat_number ? `/${addressDetails.flat_number}` : ''
        }`,
      ],
      postcode: addressDetails.post_code,
    })
  }

  const openGeoWidgetModal = () => {
    if (!window.easyPack) {
      toast({
        description: t('INPOST_MAPS_NOT_LOADED_YET_TRY_AGAIN'),
      })

      return
    }

    window.easyPack.modalMap(
      (point, modal) => {
        onPointNameChange(point.name)
        handleAddressChange(point.address_details)
        setInpostAddress({
          name: point.name,
          address: `${point.address.line1}, ${point.address.line2}`,
        })

        modal.closeModal()
      },
      {
        width: '100vw',
        height: '100vh',
      }
    )
  }

  return (
    <Box>
      {inpostAddress && (
        <Box mb={4}>
          <Text>{inpostAddress.name}</Text>
          <Text>{inpostAddress.address}</Text>
        </Box>
      )}

      <Input hidden name={name} />

      <Link
        as="button"
        type="button"
        fontWeight={300}
        onClick={openGeoWidgetModal}
      >
        {inpostAddress ? t('CHANGE') : t('CHOOSE_PARCEL_LOCKER')}
      </Link>
    </Box>
  )
}
